module.exports = __webpack_public_path__ + "img/appmalfsdk-os-icon.97625e4.png";